// page > event names

const analyticsEvents = {
    QUICK_START: {
        STEP_CHANGE: 'step_change',
    },
};

export default analyticsEvents;
